export const useApi = async (
  method: string,
  endpoint: string,
  body?: string,
  headers?: HeadersInit
) => {
  try {
    return (await fetch(`${endpoint}`, {
      method,
      body,
      headers
    }))
  } catch (requestError) {
    throw new Error(`Error: Fetch ${endpoint} failed`)
  }
}
